import React from 'react'
import TutorDashboard from './TutorDashboard'
import TutorHeader from '../TutorHeader/TutorHeader'
import { Navigate, Route, Routes } from 'react-router-dom'
import '../../../App.css'
import '../../../styles/scss/student_dashboard.css'
import '../../../styles/scss//tutor/tutor_dashboard.css'
import '../../../styles/scss/main/header.css'
import '../../../styles/scss/main/footer.css'
import '../../../styles/scss/main/breadcrum.css'
import '../../../styles/scss/main/sidebar.css'
import '../../../styles/scss/student_dashboard.css'
import '../../../styles/scss/tutor/tutor_dashboard.css'
import '../../../styles/scss/tutor/my_student.css'
import '../../../styles/scss/tutor/chat.css'
import '../../../styles/scss/student_queries.css'
import '../../../styles/scss/tutor_reviews.css'
import '../../../styles/scss/tutor_profile.css'
import '../../../styles/scss/tutor/study_material.css'
import '../../../styles/scss/tutor/add_study_material.css'
import '../../../styles/scss/tutor/course_list.css'
import '../../../styles/scss/tutor/add_new_course.css'
import '../../../styles/scss/tutor/my_schedule_details.css'
import '../../../styles/scss/tutor/my_earning.css'
import '../../../styles/scss/student/browse_tutor.css'

import TutorBooking from '../TutorBooking/TutorBooking'
import TutorMessage from '../TutorMessage/TutorMessage'
import TutorChat from '../TutorMessage/TutorChat'
import TutorStudentQueries from '../TutorStudentQueries/TutorStudentQueries'
import TutorContactUs from '../TutorContactUs/TutorContactUs'
import TutorReview from '../TutorReview/TutorReview'
import TutorProfile from '../TutorProfile/TutorProfile'
import TutorProfilePersonalInfo from '../TutorProfile/TutorProfilePersonalInfo'
import TutorProfileBankDetails from '../TutorProfile/TutorProfileBankDetails'
import TutorProfileTutoringPrice from '../TutorProfile/TutorProfileTutoringPrice'
import TutorProfileTeachingList from '../TutorProfile/TutorProfileTeachingList'
import TutorProfileCipDetails from '../TutorProfile/TutorProfileCipDetails'
import TutorMyStudentsOne from '../TutorMyStudents/TutorMyStudentsOne'
import TutorMyStudentsGroup from '../TutorMyStudents/TutorMyStudentsGroup'
import TutorFooter from '../TutorFooter/TutorFooter'
import AddStudyMaterial from '../TutorStudyMaterial/AddStudyMaterial/AddStudyMaterial'
import ViewStudyMaterial from '../TutorStudyMaterial/ViewStudyMaterial/ViewStudyMaterial'
import TutorCourses from '../TutorCourses/TutorCourses'
import TutorAddNewCourseOneToOne from '../TutorCourses/TutorCourseOneToOne/TutorAddNewCourseOneToOne/TutorAddNewCourseOneToOne'
import TutorAddNewGroupCourse from '../TutorCourses/TutorCourseGroup/TutorAddNewGroupCourse/TutorAddNewGroupCourse'
import TutorCourseList from '../TutorCourses/TutorCourseList/TutorCourseList'
import TutorAddNewSessionOneToOne from '../TutorCourses/TutorCourseOneToOne/TutorAddNewSessionOneToOne/TutorAddNewSessionOneToOne'
import TutorAddNewSessionGroup from '../TutorCourses/TutorCourseGroup/TutorAddNewSessionGroup/TutorAddNewSessionGroup'
import TutorNewBatch from '../TutorCourses/TutorCourseList/TutorNewBatch/TutorNewBatch'
import TutorBookedSchedules from '../TutorCourses/TutorBookedSchedules/TutorBookedSchedules'
import TutorMyEarnings from '../TutorMyEarnings/TutorMyEarnings'
import TutorBrowseStudents from '../TutorBrowseStudents/TutorBrowseStudents'
import TutorMySession from '../TutorBrowseStudents/TutorMySession/TutorMySession'
import TutorCreateNewSession from '../TutorBrowseStudents/TutorCreateNewSession/TutorCreateNewSession'
import TutorMyCourseDetails from '../TutorBrowseStudents/TutorMyCourseDetails/TutorMyCourseDetails'
import TutorMyAssessmentMain from '../TutorMyAssessment/TutorMyAssessmentMain'
import TutorAddObjectiveMockAssessment from '../TutorMyAssessment/TutorMockAssessment/TutorObjectiveMockAssessment/TutorAddObjectiveMockAssessment/TutorAddObjectiveMockAssessment'
import TutorAddSubjectiveMockAssessment from '../TutorMyAssessment/TutorMockAssessment/TutorSubjectiveMockAssessment/TutorAddSubjectiveMockAssessment/TutorAddSubjectiveMockAssessment'
import TutorObjectiveMockQuestions from '../TutorMyAssessment/TutorMockAssessment/TutorObjectiveMockAssessment/TutorObjectiveMockQuestions/TutorObjectiveMockQuestions'
import TutorSubjectiveMockQuestions from '../TutorMyAssessment/TutorMockAssessment/TutorSubjectiveMockAssessment/TutorSubjectiveMockQuestions/TutorSubjectiveMockQuestions'
import TutorAddObjectiveAssessment from '../TutorMyAssessment/TutorAssessment/TutorObjectiveAssessment/TutorAddObjectiveAssessment/TutorAddObjectiveAssessment'
import TutorObjectiveQuestions from '../TutorMyAssessment/TutorAssessment/TutorObjectiveAssessment/TutorObjectiveQuestions/TutorObjectiveQuestions'
import TutorAddSubjectiveAssessment from '../TutorMyAssessment/TutorAssessment/TutorSubjectiveAssessment/TutorAddSubjectiveAssessment/TutorAddSubjectiveAssessment'
import TutorSubjectiveQuestions from '../TutorMyAssessment/TutorAssessment/TutorSubjectiveAssessment/TutorSubjectiveQuestions/TutorSubjectiveQuestions'
import TutorCompletedAssessment from '../TutorMyAssessment/TutorCompletedAssessment/TutorCompletedAssessment'
import TutorSubjectiveTest from '../TutorMyAssessment/TutorCompletedAssessment/TutorSubjectiveTest/TutorSubjectiveTest'
import TutorSubjectiveTestUpdate from '../TutorMyAssessment/TutorCompletedAssessment/TutorSubjectiveTestUpdate/TutorSubjectiveTestUpdate'
import TutorObjectiveTest from '../TutorMyAssessment/TutorCompletedAssessment/TutorObjectiveTest/TutorObjectiveTest'
import TutorViewAddedAssessment from '../TutorMyAssessment/TutorCompletedAssessment/TutorViewAddedAssessment/TutorViewAddedAssessment'
import TutorNotification from '../TutorNotification/TutorNotification'
import TutorCompletedAssList from '../TutorMyAssessment/TutorCompletedAssessment/TutorCompletedAssList/TutorCompletedAssList'
import TutorStudyMaterial from '../TutorStudyMaterial/TutorStudyMaterial'
import TutorCourseBatchList from '../TutorCourses/TutorCourseList/TutorCourseBatchList'
import TutorScheduleGroupDetails from '../TutorCourses/TutorBookedSchedules/TutorScheduleGroupDetails'
import TutorScheduleOneToOneDetails from '../TutorCourses/TutorBookedSchedules/TutorScheduleOneToOneDetails'
import TutorViewAssessmentSubjectiveTest from '../TutorMyAssessment/TutorCompletedAssessment/TutorViewAddedAssessment/TutorViewAssessmentTest/TutorViewAssessmentSubjectiveTest'
import TutorViewAssessmentObjectiveTest from '../TutorMyAssessment/TutorCompletedAssessment/TutorViewAddedAssessment/TutorViewAssessmentTest/TutorViewAssessmentObjectiveTest'
import FeedbackForm from '../../FeedbackForm/FeedbackForm'
import TutorRecordedVideos from '../TutorRecordedVideos/TutorRecordedVideos'
import TutorUpdateBatch from '../TutorCourses/TutorCourseList/TutorUpdateBatch/TutorUpdateBatch'


const TutorHome = () => {


    return (
        <div>
            <TutorHeader />
            {/* /Header */}
            {/* Sidebar */}
            {/* <Sidebar sidebar="sidebar" sidebarMenu="sidebar-menu" CustomerProfileData={CustomerProfileData} /> */}
            {/* /Sidebar */}



            <Routes>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="*" element={<Navigate to="dashboard" />} />
                <Route path='dashboard' element={<TutorDashboard />} />
                <Route path='bookings' element={<TutorBooking />} />
                <Route path='message' element={<TutorMessage />} />
                <Route path='chat/:b64id' element={<TutorChat />} />
                <Route path='student-queries' element={<TutorStudentQueries />} />
                <Route path='contact-us' element={<TutorContactUs />} />
                <Route path='reviews' element={<TutorReview />} />
                <Route path='profile-settings' element={<TutorProfile />} />
                <Route path='profile-settings-personal-info' element={<TutorProfilePersonalInfo />} />
                <Route path='profile-settings-bank-details' element={<TutorProfileBankDetails />} />
                <Route path='profile-settings-updated-tutoring-price' element={<TutorProfileTutoringPrice />} />
                <Route path='profile-settings-tutor-teaching-list' element={<TutorProfileTeachingList />} />
                <Route path='profile-settings-cip' element={<TutorProfileCipDetails />} />
                <Route path='my-students' element={<TutorMyStudentsOne />} />
                <Route path='my-students-group' element={<TutorMyStudentsGroup />} />
                <Route path='my-schedule-one-to-one-details/:b64id' element={<TutorScheduleOneToOneDetails />} />
                <Route path='my-schedule-group-details/:b64id' element={<TutorScheduleGroupDetails />} />
                <Route path='study-material' element={<TutorStudyMaterial />} />
                <Route path='add-study-material' element={<AddStudyMaterial />} />
                <Route path='view-study-material/:b64id' element={<ViewStudyMaterial />} />
                <Route path='my-courses' element={<TutorCourses />} />
                <Route path='add-new-course-one-to-one' element={<TutorAddNewCourseOneToOne />} />
                <Route path='add-new-group-course' element={<TutorAddNewGroupCourse />} />
                <Route path='group-course-list' element={<TutorCourseList />} />
                <Route path='group-course-batch-list/:b64id' element={<TutorCourseBatchList />} />
                <Route path='booked-schedule' element={<TutorBookedSchedules />} />
                <Route path='create-new-session-one-to-one' element={<TutorAddNewSessionOneToOne />} />
                <Route path='create-new-session-group' element={<TutorAddNewSessionGroup />} />
                <Route path='create-new-batch/:b64id' element={<TutorNewBatch />} />
                <Route path='update-batch' element={<TutorUpdateBatch />} />
                <Route path='my-earnings' element={<TutorMyEarnings />} />
                <Route path='browse-students' element={<TutorBrowseStudents />} />

                <Route path='my-session/:b64id' element={<TutorMySession />} />
                <Route path='create-new-session/:b64id' element={<TutorCreateNewSession />} />
                <Route path='my-course-details/:b64id' element={<TutorMyCourseDetails />} />
                <Route path='my-assessments-main' element={<TutorMyAssessmentMain />} />
                <Route path='add-mock-objective-assessment' element={<TutorAddObjectiveMockAssessment />} />
                <Route path='add-mock-objective-questions/:b64id' element={<TutorObjectiveMockQuestions />} />
                <Route path='add-mock-subjective-assessment' element={<TutorAddSubjectiveMockAssessment />} />
                <Route path='add-mock-subjective-questions' element={<TutorSubjectiveMockQuestions />} />

                <Route path='add-objective-assessment' element={<TutorAddObjectiveAssessment />} />
                <Route path='add-objective-questions' element={<TutorObjectiveQuestions />} />
                <Route path='add-subjective-assessment' element={<TutorAddSubjectiveAssessment />} />
                <Route path='add-subjective-questions' element={<TutorSubjectiveQuestions />} />

                <Route path='completed-assessment' element={<TutorCompletedAssessment />} />
                <Route path='completed-assessment-student-list/:b64id' element={<TutorCompletedAssList />} />
                <Route path='tutor-subjective-test' element={<TutorSubjectiveTest />} />
                <Route path='tutor-subjective-test-update' element={<TutorSubjectiveTestUpdate />} />
                <Route path='tutor-objective-test' element={<TutorObjectiveTest />} />

                <Route path='view-assessment-course' element={<TutorViewAddedAssessment />} />
                <Route path='view-assessment-subjective-test/:b64id' element={<TutorViewAssessmentSubjectiveTest />} />
                <Route path='view-assessment-objective-test/:b64id' element={<TutorViewAssessmentObjectiveTest />} />

                <Route path='notification' element={<TutorNotification />} />
                <Route path='recordings/:b64id' element={<TutorRecordedVideos />} />
            </Routes>
            <FeedbackForm />
            <TutorFooter />
        </div>
    )
}

export default TutorHome